/**
 * @generated SignedSource<<1c4c016b51d0b316f96366625e3e0c8b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeaturedContentCarousel_featuredContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blocksPerRow",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "autoplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slidesInterval",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeaturedContentBlock",
      "kind": "LinkedField",
      "name": "featuredContentBlocks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FeaturedContentBlock_block"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PageSectionFeaturedContent",
  "abstractKey": null
};

node.hash = "65ab238ac13aeb169a8a26a7f26d3120";

module.exports = node;
